import { createHash } from "utils/createHash";
import { GameData, User } from "types";

export function createRequest(
  user: User,
  gameData: GameData,
  status = "pending",
) {
  const id = createHash(user.uid + gameData.id);
  const reqData = {
    id,
    gameId: gameData.id,
    senderId: user.uid,
    receiverId: gameData.hostId,
    senderName: user.displayName,
    gameName: gameData.gameName,
    timeStamp: Date.now(),
    status,
  };

  return reqData;
}
